/**
 * TanStack Router: /performance/radar/:employeeId
 *
 * Individual employee radar view with tabs.
 * Supports tab query param and comparison mode.
 *
 * @see packages/web-apps/monutrack/docs/PERFORMANCE-RADAR-frontend-spec.md
 */
import { createFileRoute } from '@tanstack/react-router'
import { RadarViewPage } from '@/components/performance/radar/RadarViewPage'
import { z } from 'zod'

/**
 * Search params schema for radar view
 */
const searchSchema = z.object({
  tab: z.enum(['individual', 'leader', 'matrix']).optional().default('individual'),
  compare: z.string().optional(),
})

/**
 * Route: /performance/radar/:employeeId
 * Layout: _auth/performance/radar
 * Component: RadarViewPage
 *
 * Query Params:
 * - tab: 'individual' | 'leader' | 'matrix' (default: 'individual')
 * - compare: string (optional employee ID for comparison)
 */
export const Route = createFileRoute('/_auth/performance/radar/$employeeId/')({
  validateSearch: searchSchema,
  component: RadarViewPage,
})
